export class UserSession {
  authToken: string;
  logTime: Date;

}
